module.exports = __webpack_public_path__ + "static/media/file-arrow-down-solid.ab8481ad.svg";